export default __webpack_public_path__ + "static/media/mars6.8fe88691.gif";